import React, { ComponentProps } from "react";

export default function CrownIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M15.8335 7.69171L13.6918 8.22505L11.0168 4.89171C10.8955 4.75218 10.7458 4.64029 10.5775 4.56362C10.4093 4.48694 10.2266 4.44727 10.0418 4.44727C9.85693 4.44727 9.67423 4.48694 9.50603 4.56362C9.33782 4.64029 9.18804 4.75218 9.06679 4.89171L6.39179 8.22505L4.20846 7.69171C3.99921 7.64163 3.78063 7.64604 3.57357 7.70452C3.36652 7.76299 3.17792 7.87357 3.02578 8.02571C2.87365 8.17784 2.76306 8.36645 2.70459 8.5735C2.64612 8.78055 2.64171 8.99914 2.69179 9.20838L4.11679 14.8834C4.18228 15.1544 4.3371 15.3955 4.55629 15.5678C4.77548 15.7402 5.0463 15.8337 5.32512 15.8334H14.6751C14.9539 15.8337 15.2248 15.7402 15.444 15.5678C15.6631 15.3955 15.818 15.1544 15.8835 14.8834L17.3085 9.20838C17.3558 9.00328 17.351 8.78958 17.2944 8.58683C17.2378 8.38409 17.1312 8.19878 16.9845 8.04788C16.8377 7.89697 16.6555 7.7853 16.4544 7.72308C16.2533 7.66085 16.0398 7.65007 15.8335 7.69171Z"
        fill="#D9D9D9"
      />
      <path
        d="M2.29167 7.08333C2.86696 7.08333 3.33333 6.61696 3.33333 6.04167C3.33333 5.46637 2.86696 5 2.29167 5C1.71637 5 1.25 5.46637 1.25 6.04167C1.25 6.61696 1.71637 7.08333 2.29167 7.08333Z"
        fill="#D9D9D9"
      />
      <path
        d="M17.7082 7.08333C18.2835 7.08333 18.7498 6.61696 18.7498 6.04167C18.7498 5.46637 18.2835 5 17.7082 5C17.1329 5 16.6665 5.46637 16.6665 6.04167C16.6665 6.61696 17.1329 7.08333 17.7082 7.08333Z"
        fill="#D9D9D9"
      />
      <path
        d="M10.0002 3.54134C10.5755 3.54134 11.0418 3.07497 11.0418 2.49967C11.0418 1.92438 10.5755 1.45801 10.0002 1.45801C9.42487 1.45801 8.9585 1.92438 8.9585 2.49967C8.9585 3.07497 9.42487 3.54134 10.0002 3.54134Z"
        fill="#D9D9D9"
      />
      <path
        d="M14.9998 18.3337H4.99984C4.77882 18.3337 4.56686 18.2459 4.41058 18.0896C4.2543 17.9333 4.1665 17.7213 4.1665 17.5003C4.1665 17.2793 4.2543 17.0673 4.41058 16.9111C4.56686 16.7548 4.77882 16.667 4.99984 16.667H14.9998C15.2209 16.667 15.4328 16.7548 15.5891 16.9111C15.7454 17.0673 15.8332 17.2793 15.8332 17.5003C15.8332 17.7213 15.7454 17.9333 15.5891 18.0896C15.4328 18.2459 15.2209 18.3337 14.9998 18.3337Z"
        fill="#D9D9D9"
      />
    </svg>
  );
}
